<section class="page-control">
  <div class="flex justify-content-between w-full align-items-center">
    <h2>Proizvodi</h2>
    <button class="main-btn" [routerLink]="['./add']">
      Dodaj <i class="pi pi-plus"></i>
    </button>
  </div>
</section>

<section class="page-control">
  <div class="grid w-full">
    <!-- FILTER FIELDS  -->
    <div class="col-12 sm:col-10">
      <form [formGroup]="form" class="grid">
        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Šifra proizvoda</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="label"
          />
        </div>

        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Naziv proizvoda</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="name"
          />
        </div>

        <div class="col-4 type-multiselect">
          <label class="mb-2 block">Tip proizvoda</label>
          <p-dropdown
            [options]="productTypes"
            placeholder="Svi tipovi"
            optionLabel="name"
            optionValue="id"
            [filter]="true"
            formControlName="product_type_id"
            class=""
          >
            <ng-template let-option pTemplate="item">
              <div class="p-multiselect-representative-option">
                <span class="ml-1">{{ option.name }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </form>
    </div>

    <!-- FILTER BUTTONS -->
    <div
      class="flex flex-column justify-content-around col-12 sm:col-2 align-items-end"
    >
      <button class="main-btn w-10rem mt-2" (click)="onResetFilter()">
        Osveži <i class="pi pi-refresh"></i>
      </button>
    </div>
  </div>
</section>

<p-table
  #dt1
  [value]="products.data"
  dataKey="id"
  [rows]="10"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines"
  [paginator]="false"
  currentPageReportTemplate="Prikaz od {first}. do {last}. proizvoda od ukupno {totalRecords}"
  [globalFilterFields]="['label', 'name']"
>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="label">
        <div class="flex justify-content-between align-items-center">
          Šifra proizvoda
          <p-sortIcon field="label"></p-sortIcon>
          <!-- <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> -->
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Naziv
          <!-- <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> -->
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Redosled operacija
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Tip
          <!-- <p-columnFilter type="text" field="product_type.name" display="menu"></p-columnFilter> -->
        </div>
      </th>
      <th style="width: 10rem">
        <div class="flex justify-content-between align-items-center">
          Akcija
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-products>
    <tr>
      <td>
        {{ products.label }}
      </td>
      <td>
        <span class="image-text">{{ products.name }}</span>
      </td>
      <td>
        <span class="image-text">
          <span
            class="badge mr-1"
            *ngFor="let operations of products.operations"
          >
            {{ operations.operation.label }}
          </span>
        </span>
      </td>
      <td>
        {{ products?.product_type?.name }}
      </td>
      <td class="text-center">
        <a
          class="second-btn small-btn mr-2"
          pTooltip="Izmeni"
          tooltipPosition="top"
          (click)="onEditProduct(products)"
          [routerLink]="['edit', products.id]"
        >
          <i class="pi pi-pencil"></i>
        </a>

        <button
          class="second-btn small-btn"
          type="button"
          pTooltip="Izbriši"
          tooltipPosition="top"
          (click)="onDeleteProduct(products.id)"
        >
          <i class="pi pi-trash"></i>
        </button>

        <a
          class="second-btn small-btn ml-2"
          pTooltip="Kopiraj"
          tooltipPosition="top"
          (click)="onCopyProduct(products)"
          [routerLink]="['copy']"
        >
          <i class="pi pi-copy"></i>
        </a>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">Ni jedan proizvod nije pronađen.</td>
    </tr>
  </ng-template>
</p-table>

<p-paginator
  #paginatorElement
  *ngIf="products.pagination"
  [first]="1"
  styleClass="mb-4"
  [rows]="100"
  [showJumpToPageDropdown]="true"
  [showPageLinks]="true"
  [totalRecords]="totalPagination"
  (onPageChange)="onPageChange($event)"
  [showPageLinks]="false"
  [rowsPerPageOptions]="[10, 50, 100, 250]"
></p-paginator>
